import { render, staticRenderFns } from "./ReceiptDeliveryDialog.vue?vue&type=template&id=225bd1c2&scoped=true"
import script from "./ReceiptDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./ReceiptDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDeliveryDialog.vue?vue&type=style&index=0&id=225bd1c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225bd1c2",
  null
  
)

export default component.exports